/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesTerminateService } from "../../funcs/computeServicesTerminateService.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.TerminateServiceRequest$inboundSchema,
};

export const tool$computeServicesTerminateService: ToolDefinition<typeof args> =
  {
    name: "compute-services-terminate-service",
    description: `Terminate a service`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeServicesTerminateService(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
